export default __webpack_public_path__ + "locales/sq-AL/PortalUnavailable.json?hash=2bfbac7a9a953df96dd6944df291eb1a";